import { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { AmendmentCreateEditState, AmendmentCreateEditReducer, ACTION_TYPES } from './amendment-create-edit-reducer';
export { ACTION_TYPES };

const AmendmentCreateEditContext = createContext<AmendmentCreateEditState | undefined>(undefined);
const AmendmentCreateEditDispatchContext = createContext({} as any);

export const AmendmentCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { amendmentId } = useParams();
    const initialState: AmendmentCreateEditState = {
        amendmentId,
        amendmentRequest: { year: new Date().getFullYear() },
        parlamentarians: [],
        politicalParties: [],
        budgetUnits: [],
        selectedBudgetUnitId: undefined,
        budgetPrograms: [],
        selectedBudgetProgramId: undefined,
        budgetActions: [],
        files: [],
        showValidationErrors: false,
    };
    const [state, dispatch] = useReducer(AmendmentCreateEditReducer, initialState);
    return (
        <AmendmentCreateEditContext.Provider value={state}>
            <AmendmentCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </AmendmentCreateEditDispatchContext.Provider>
        </AmendmentCreateEditContext.Provider>
    );
};

export const useAmendmentCreateEditState = () => {
    const context = useContext(AmendmentCreateEditContext);
    if (!context) throw new Error('useAmendmentCreateEditState must be used within AmendmentCreateEditProvider');
    return context;
};

export const useAmendmentCreateEditDispatch = () => {
    const context = useContext(AmendmentCreateEditDispatchContext);
    if (!context) throw new Error('useAmendmentCreateEditDispatch must be used within AmendmentCreateEditProvider');
    return context;
};
